<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head">CONTENTS</p>
<table>
<colgroup>
<col width="40px"/>
<col width="350px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span class="remove" href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span class="remove" href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><span class="remove" href="#/Dedication" title="Link target outside of Sample">Dedication</span></td></tr>
<tr><td colspan="2" id="ack"><a class="remove" href="#/Acknowledgments">Acknowledgments</a></td></tr>
<tr><td colspan="2" id="INT"><a class="remove" href="#/Introduction">Introduction</a></td></tr>
<tr><td id="IN1"><span class="remove" href="#/Chapter1#C1" title="Link target outside of Sample">1.</span></td><td><span class="remove" href="#/Chapter1#C1" title="Link target outside of Sample">The Early Years and Ski Jumping</span></td></tr>
<tr><td id="IN2"><span class="remove" href="#/Chapter2#C2" title="Link target outside of Sample">2.</span></td><td><span class="remove" href="#/Chapter2#C2" title="Link target outside of Sample">Getting Slopeside Was Half the Fun</span></td></tr>
<tr><td id="IN3"><span class="remove" href="#/Chapter3#C3" title="Link target outside of Sample">3.</span></td><td><span class="remove" href="#/Chapter3#C3" title="Link target outside of Sample">Fashion, Style, and Flair</span></td></tr>
<tr><td id="IN4"><span class="remove" href="#/Chapter4#C4" title="Link target outside of Sample">4.</span></td><td><span class="remove" href="#/Chapter4#C4" title="Link target outside of Sample">Food, Entertainment, and Rest</span></td></tr>
<tr><td id="IN5"><span class="remove" href="#/Chapter5#C5" title="Link target outside of Sample">5.</span></td><td><span class="remove" href="#/Chapter5#C5" title="Link target outside of Sample">Ski Clubs and Organizations</span></td></tr>
<tr><td id="IN6"><span class="remove" href="#/Chapter6#C6" title="Link target outside of Sample">6.</span></td><td><span class="remove" href="#/Chapter6#C6" title="Link target outside of Sample">The Great Northern Catskills</span></td></tr>
<tr><td id="IN7"><span class="remove" href="#/Chapter7#C7" title="Link target outside of Sample">7.</span></td><td><span class="remove" href="#/Chapter7#C7" title="Link target outside of Sample">Belleayre Mountain and Points South</span></td></tr>
<tr><td id="IN8"><span class="remove" href="#/Chapter8#C8" title="Link target outside of Sample">8.</span></td><td><span class="remove" href="#/Chapter8#C8" title="Link target outside of Sample">Gone Home</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?5b0326c3